module.exports = __webpack_public_path__ + "img/1.8c6de7ee.jpg";